import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

interface IParams {
  order_uid: string;
  status_uid: string;
  version: string;
}

export const useMoveToStatusQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ order_uid, status_uid, version }: IParams) => {
      await Api.orders.postMoveToStatus(order_uid, status_uid, version);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      client.invalidateQueries(['getOrdersByProcess']);
      client.invalidateQueries(['getOrders']);
      client.invalidateQueries(['getOrder']);
    },
    onError: () => {
      client.invalidateQueries(['getOrdersByProcess']);
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
